import { render, staticRenderFns } from "./OpsiyonDuzenle.vue?vue&type=template&id=8c008b1a&scoped=true&"
import script from "./OpsiyonDuzenle.vue?vue&type=script&lang=js&"
export * from "./OpsiyonDuzenle.vue?vue&type=script&lang=js&"
import style1 from "./OpsiyonDuzenle.vue?vue&type=style&index=1&id=8c008b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c008b1a",
  null
  
)

export default component.exports